const aws = {
  region: 'eu-west-1',
  identityPoolId: 'eu-west-1:fd6c7584-ec3f-4857-8d8d-9ee9fc4c80bd',
  userPoolId: 'eu-west-1_z7HrmSsZ0',
  userPoolClientId: '7nv580d2s52vknorhu2olusbmi',
  productionManagementAppsyncEndpoint: 'https://m7uhc2lyd5ay5gu57vycfz4nni.appsync-api.eu-west-1.amazonaws.com/graphql',
  userManagementAppsyncEndpoint: 'https://hoi7lnfbzvgsbc5dng6sfhbofi.appsync-api.eu-west-1.amazonaws.com/graphql',
};
export default aws;
